export enum InvoiceStatus {
  DRAFT = 'draft',
  OPEN = 'open',
  SETTLED = 'settled',
  VOID = 'void',
  UNCOLLECTIBLE = 'uncollectible',
  DELETED = 'deleted'
}
